// Older partial-duration resources may carry a JSON-encoded list as their name.
export const resourceLabel = (value) => {
  if (Array.isArray(value)) return value.map(resourceLabel).filter(Boolean).join(", ");
  if (typeof value !== "string") return value == null ? "" : String(value);
  if (value.trim().startsWith("[")) {
    try {
      const names = JSON.parse(value);
      if (Array.isArray(names) && names.every((name) => typeof name === "string")) return resourceLabel(names);
    } catch (_) { /* A literal name containing brackets is still a valid name. */ }
  }
  return value;
};

export const normalizeResourceOptionLabels = (value) => {
  if (Array.isArray(value)) return value.map(normalizeResourceOptionLabels);
  if (!value || typeof value !== "object") return value;
  return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key,
    ["label", "resource_name", "resource_item", "resource_item_name"].includes(key)
      ? resourceLabel(entry)
      : ["resource_requirements", "requirements", "resource_items", "options"].includes(key)
        ? normalizeResourceOptionLabels(entry) : entry,
  ]));
};
